import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-16 bg-navy text-white" data-id="element-36">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-37">
        <FadeIn data-id="element-38">
          <div className="flex flex-col md:flex-row items-center justify-center gap-8 text-center md:text-left" data-id="element-39">
            <div className="w-24 h-24 rounded-full bg-gold/20 flex items-center justify-center flex-shrink-0" data-id="element-40">
              <ShieldCheck className="w-12 h-12 text-gold" data-id="element-41" />
            </div>
            <div data-id="element-42">
              <h2 className="text-2xl md:text-3xl font-bold text-beige mb-3" data-id="element-43">
                7 días de garantía total
              </h2>
              <p className="text-lg text-beige/80 max-w-xl" data-id="element-44">
                Probá Piano Fácil PRO sin riesgo. Si no te convence o sentís que
                no es para vos, te devolvemos el 100% de tu dinero. Sin
                preguntas.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}